<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('btn.edit') : t('btn.add')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="configName"
        :label="mPageType === 'ratingRules' ? t('operate.8u7ow3') : t('operate.zt8cn9')"
        :rules="[{ required: true, message: t('common.pleaseInput') }]"
      >
        <a-input v-model:value="editForm.configName" :placeholder="t('common.pleaseInput')" v-trim />
      </a-form-item>
      <div style="display: flex; align-items: center; margin-top: 5px">
        <a-form-item
          name="min"
          :label="mPageType === 'ratingRules' ? t('operate.gihkns') : t('operate.1eiz0j')"
          :rules="[{ required: true, message: t('common.pleaseInput') }]"
        >
          <div style="display: flex; align-items: center; margin-top: 5px">
            <p style="width: 100px">{{ t('common.moreThan') }}:</p>
            <a-input-number
              v-model:value="editForm.min"
              :precision="0"
              :maxlength="10"
              :placeholder="t('common.pleaseInput')"
            />
          </div>
        </a-form-item>
        <a-form-item
          name="max"
          label=""
          :rules="[{ required: true, message: t('common.pleaseInput') }]"
          style="margin: 5px 0 0 10px"
          class="down-box"
        >
          <div style="display: flex; align-items: center; margin-top: 5px">
            <p style="width: 100px">{{ t('common.lessThan') }}:</p>
            <a-input-number
              v-model:value="editForm.max"
              :precision="0"
              :maxlength="10"
              :placeholder="t('common.pleaseInput')"
            />
          </div>
        </a-form-item>
      </div>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, watch } from 'vue'
import { ratingRulesSave, ratingRulesUpdate } from '@/api/overseasSales/ratingRules'
import type { FormInstance } from 'ant-design-vue'
import { RatingRulesSaveParams } from '@/typings/api/overseasSales'
import { message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()

const props = defineProps({
  pageType: {
    type: String,
    default: 'ratingRules'
  }
})
const mPageType = ref<string>()

watch(
  props,
  () => {
    mPageType.value = props.pageType
  },
  { immediate: true }
)
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<RatingRulesSaveParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: RatingRulesSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { configName, max, min } = editForm.value
    console.log('mPageType.value: ', mPageType.value)
    const p = {
      configName,
      max,
      min,
      logic: `>${editForm.value.min},≤${editForm.value.max}`,
      configType: mPageType.value === 'ratingRules' ? 2 : 1,
      appId: 'cos_ofbu'
    }
    try {
      if (editForm.value.id) {
        await ratingRulesUpdate({ ...p, id: editForm.value.id })
      } else {
        await ratingRulesSave(p)
      }
      // toggle()
      loading.value = false
      visible.value = !visible.value
      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss" scoped>
:deep(.ant-form-item-with-help .ant-form-item-explain) {
  left: 70px !important;
}
</style>
